import { Accordion } from '@base-ui/react/accordion';
import styled from 'styled-components';
import { pxToRem } from 'modules/v2/foundation/spacing';
import { themeGet } from 'modules/v2/foundation/theme';
export const Header = styled(Accordion.Header) `
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
`;
export const Trigger = styled(Accordion.Trigger) `
  padding: ${themeGet('spacing.xs')} ${themeGet('spacing.md')};
  border-radius: ${themeGet('borderRadius.md')};
  display: flex;
  align-items: center;
  gap: ${themeGet('spacing.lg')};
  color: ${themeGet('colors.text.300')};
  cursor: pointer;

  &:focus-visible {
    outline: none;
    border: none;
    box-shadow: inset 0 0 0 ${pxToRem(2)} ${themeGet('colors.focus.primary')};
  }

  &:hover {
    background-color: ${themeGet('colors.gray.50')};
  }

  [data-icon='falcon'] {
    transition: ${themeGet('motion.duration.normal')};
  }

  &[data-panel-open] {
    [data-icon='falcon'] {
      transform: rotate(90deg);
    }
  }
`;
export const ActionsContainer = styled.div `
  display: flex;
  align-items: center;
  gap: ${themeGet('spacing.sm')};
`;
